import { z } from 'zod';
import { uuidish } from '../../utils/uuidish.js';
export const identifiableValidationSchema = z.object({
    id: uuidish.describe('id is required'),
});
//# sourceMappingURL=identifiable-validation-schema.js.map